<template>
  <div>

    <lk-form slot='content' :model='goodsForm' :rules='validate' :label-width='134'
      label-position="right" ref="goodsForm">
      <div class="cardContainer">

        <lk-card title='基础商品信息'>

          <!-- 商品最开始验证部分 -->

          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='通用名:' prop='approvedDrugNames' ref="approvedDrugNames">
                <div v-if="able">
                  <goodsDropDownInput v-if='isAdd && isInStore'
                  :type='1'  @selected='handleSelect' v-model.trim="goodsForm.approvedDrugNames"
                  @on-blur='setMnemonicCode'></goodsDropDownInput>
                  <lk-input  v-else @on-change='setMnemonicCode(goodsForm.approvedDrugNames)'  :maxlength='40' clearable placeholder="请输入"
                    v-model.trim="goodsForm.approvedDrugNames"></lk-input>
                </div>
                <span v-else>{{goodsForm.approvedDrugNames}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='商品名:' prop='goodsName'>
                <lk-input :maxlength='20' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.goodsName"></lk-input>
                <span v-else>{{goodsForm.goodsName}}</span>
              </lk-form-item>
            </lk-col>


            <lk-col span='7' :offset='1'>
              <lk-form-item label='批准文号:' prop='approvalNumber'>
                <lk-select v-if="able" v-model="goodsForm.approvalNumberType" @on-change='valideApprovalNumber'
                  style="width:40%" :disabled='disabledSearch'>
                  <lk-option :key="index" :value='item'
                    v-for="(item,index) in baseData.approvalNumberTypeArr">{{item}}
                  </lk-option>
                  <!-- <lk-option :value='1'>进口药品注册证</lk-option> -->
                </lk-select>
                <lk-input  style="width:60%" v-if="able"
                  :disabled='disabledSearch'
                  v-model.trim="goodsForm.approvalNumber"></lk-input>
                <span v-else>{{goodsForm.approvalNumberType+goodsForm.approvalNumber}}</span>

              </lk-form-item>
            </lk-col>
          </lk-row>

          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='包装规格:' prop='specifications'>
                <lk-input :maxlength='32' v-if="able" placeholder="请输入" :disabled='isInStore&&disabledSearch'
                  v-model.trim="goodsForm.specifications"></lk-input>
                <span v-else>{{goodsForm.specifications}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='药品规格:'>
                <lk-input :maxlength='100' v-if="able" placeholder="请输入"
                  v-model.trim="goodsForm.drugSpec"></lk-input>
                <span v-else>{{goodsForm.drugSpec}}</span>
              </lk-form-item>
            </lk-col>

            <lk-col span='7' :offset='1'>
              <lk-form-item label='包装单位:' prop='drugMiniPackageUnit'>
                <lk-select v-if="able" clearable
                  v-model.trim="goodsForm.drugMiniPackageUnit" :disabled='!isAdd || isImport'>
                  <lk-option v-for="(item,index) in baseData.drugMiniPackageUnitArr" :key="index"
                    :value='item. dictionaryIndex'>{{item.dictionaryName}}</lk-option>
                  <!-- <lk-option :value='1'>盒</lk-option> -->
                </lk-select>
                <span
                  v-else>{{goodsForm.drugMiniPackageUnitString}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
            <lk-col span='7'>
              <lk-form-item label='化学成分:' prop='chemicalComposition'>
                <lk-input :maxlength='50' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.chemicalComposition"></lk-input>
                <span v-else>{{goodsForm.chemicalComposition}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='成分分类:' prop='chemistryType'>
                <lk-input :maxlength='50' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.chemistryType"></lk-input>
                <span v-else>{{goodsForm.chemistryType}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='制剂单位:' prop='preparationUnit'>
                <lk-select v-if="able" clearable v-model.trim="goodsForm.preparationUnit">
                  <lk-option v-for="(item,index) in baseData.preparationUnitArr" :key="index"
                    :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
                  <!-- <lk-option :value='1'>片剂</lk-option> -->
                </lk-select>
                <span v-else>{{goodsForm.preparationUnitString}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter="16">
          <lk-col span='7'>
              <lk-form-item label='剂型:' prop='dosageForm'>
                <lk-select v-if="able" filterable clearable
                  v-model.trim="goodsForm.dosageForm">
                  <lk-option v-for="(item,index) in baseData.dosageFormArr" :key="index"
                    :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
                  <!-- <lk-option :value='1'>片剂</lk-option> -->
                </lk-select>
                <span v-else>{{goodsForm.dosageFormString}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='生产企业:' prop='manufacturer'>
                <lk-input :maxlength='100' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.manufacturer"></lk-input>
                <span v-else>{{goodsForm.manufacturer}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='产地:' prop='countryOfOrigin'>
                <lk-input :maxlength='20' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.countryOfOrigin"></lk-input>
                <span v-else>{{goodsForm.countryOfOrigin}}</span>
              </lk-form-item>
            </lk-col>

          </lk-row>
          <lk-row :gutter="16">
           <lk-col span='7'>
              <lk-form-item label='是否进口:' prop='isImport'>
                <lk-radio-group v-if="able" v-model.trim="goodsForm.isImport">
                  <lk-radio :label="1" :value="1" disabled>是</lk-radio>
                  <lk-radio :label="2" :value="2" disabled>否</lk-radio>
                </lk-radio-group>
                <span v-else>{{goodsForm.isImport|judgeToString}}</span>
              </lk-form-item>
              <lk-form-item label='本位码:' prop='ndcNumber'>
                <lk-input :maxlength='14' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.ndcNumber"></lk-input>
                <span v-else>{{goodsForm.ndcNumber}}</span>
              </lk-form-item>
            </lk-col>
             <lk-col span='7' :offset='1'>
              <lk-form-item label='储存条件:' prop='storageConditions' ref="storageConditions">
                <div >
                  <lk-select v-if="able" clearable
                    v-model.trim="goodsForm.storageConditions"
                    @on-change='handleStorageConditions'
                    :class="{'other':goodsForm.storageConditions === 6}">
                    <lk-option v-for="(item,index) in baseData.storageConditionsArr" :key="index"
                      :value='item.dictionaryIndex'>{{item.dictionaryName}}</lk-option>
                  </lk-select>
                  <lk-input :maxlength='10' style="width:60%" v-if="able && goodsForm.storageConditions === 6"
                    v-model.trim="goodsForm.otherStorageCondition"></lk-input>

                  <span v-if='!able'>
                    <span>
                      {{goodsForm.storageConditionsStringNew}}
                    </span>
                  </span>
                </div>
              </lk-form-item>
              <lk-form-item v-if="able&&goodsForm.storageConditions > 0" prop='temp'>
                <div  class="fakeFormItem">
                    <label style="width:26px">温度：</label>
                    <lk-input-number v-model="goodsForm.minTemp" style="width:calc(50% - 25px)"
                    placeholder="最低温度"
                      :formatter="value => `${value}℃`" :parser="value => value.replace('℃', '')"
                      :max='99.9' :min='-99.9' :precision='1' :active-change='false'>
                    </lk-input-number>
                    <label style="margin:0 4px">-</label>
                    <lk-input-number v-model="goodsForm.maxTemp" style="width:calc(50% - 25px)"
                    placeholder="最高温度"
                      :formatter="value => `${value}℃`" :parser="value => value.replace('℃', '')"
                      :max='99.9' :min='-99.9' :precision='1' :active-change='false'>
                    </lk-input-number>
                  </div>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='质检标准:' prop='drugAcceptanceStandard'>
                <lk-input :maxlength='50' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.drugAcceptanceStandard"></lk-input>
                <span v-else>{{goodsForm.drugAcceptanceStandard}}</span>
              </lk-form-item>
              <drugInstruction :approvalNumber='goodsForm.approvalNumber' :approvedDrugNames='goodsForm.approvedDrugNames'
                :manufacturer='goodsForm.manufacturer' :specifications='goodsForm.specifications'></drugInstruction>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='条形码:' prop='barCode'>
                <lk-input :maxlength='20' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.barCode"></lk-input>
                <span v-else>{{goodsForm.barCode}}</span>
              </lk-form-item>
            </lk-col>
             <lk-col span='7' :offset='1'>
               <lk-form-item label='用法:' prop='goodsUsageName'>
                 <select-input v-if="able" v-model="goodsForm.goodsUsage"
                   :otherStr='goodsForm.otherGoodsUsage' :options='baseData.usageArr'
                   name='dictionaryName' keyName='dictionaryIndex' @setOther='val=>{goodsForm.otherGoodsUsage=val}'></select-input>
                 <span v-else>{{goodsForm.otherGoodsUsage||goodsForm.goodsUsageName}}</span>
               </lk-form-item>
             </lk-col>
             <lk-col span='7' :offset='1'>
               <lk-form-item label='频次:' prop='packers'>
                 <select-input v-if="able" v-model="goodsForm.frequency"
                   :otherStr='goodsForm.otherFrequency' :options='baseData.frequencyArr'
                   name='dictionaryName' keyName='dictionaryIndex' @setOther='val=>{goodsForm.otherFrequency=val}'></select-input>
                 <span v-else>{{goodsForm.otherFrequency||goodsForm.frequencyName}}</span>
               </lk-form-item>
             </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='每次用量:' prop='dosage'>
                  <lk-input v-if="able" v-model='goodsForm.dosage' placeholder="请输入"></lk-input>
                <span v-else>{{goodsForm.dosage}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='原批准文号:' prop='oldApprovalNumber'>
                <lk-input :maxlength='100' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.oldApprovalNumber"></lk-input>
                <span v-else>{{goodsForm.oldApprovalNumber}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='分装企业:' prop='packers'>
                <lk-input :maxlength='100' v-if="able" clearable placeholder="请输入"
                  v-model.trim="goodsForm.packers"></lk-input>
                <span v-else>{{goodsForm.packers}}</span>
              </lk-form-item>
            </lk-col>

          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='商品分类:' prop='indicationDicId'>
                <lk-cascader v-if="able" clearable :data="baseData.indicationTree"
                  v-model.trim="indicationDicArray"></lk-cascader>
                <span v-else>{{goodsForm.indicationDicString}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='是否数据直连:' prop='isDataLink'>
                <lk-radio-group v-if="able" clearable v-model.trim="goodsForm.isDataLink">
                  <lk-radio :label="1" :value="1">是</lk-radio>
                  <lk-radio :label="2" :value="2">否</lk-radio>
                </lk-radio-group>
                <span v-else>{{goodsForm.isDataLink|judgeToString}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='说明书:' prop='manualUrl'>
                <Uploader :able='able' v-model='goodsForm.manualUrl'></Uploader>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row  :gutter='16'>
              <lk-col span='7'>
                  <lk-form-item label='药品图片(外包装):' prop='drugImageUrl'>
                    <Uploader :able='able' v-model.trim="goodsForm.drugImageUrl">
                    </Uploader>
                  </lk-form-item>
             </lk-col>
              <lk-col span='7'  :offset='1'>
              <lk-form-item label='上市许可持有人:' prop='mah'>
                <lk-input v-if='able' :maxlength='100' v-model='goodsForm.mah' placeholder="请输入"></lk-input>
                <span v-else>{{goodsForm.mah}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' offset='1'>
              <lk-form-item label='最大处方数量:' prop='maxRxNum'>
                <NumberInput :disabled='isStoreAccount' v-if='able' :maxlength='8' v-model='goodsForm.maxRxNum' size='default' placeholder="请输入"></NumberInput>
                <span v-else>{{goodsForm.maxRxNum}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
           </lk-row>
           <!-- 顺丰增加字段 -->
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='是否启用配送:' prop='isDockSf'>
                <lk-radio-group v-if="able" clearable v-model="goodsForm.isDockSf">
                  <lk-radio :label="1" :value="1">是</lk-radio>
                  <lk-radio :label="2" :value="2">否</lk-radio>
                </lk-radio-group>
                <span v-else>{{goodsForm.isDockSf ===1 ? '是': '否'}}</span>
              </lk-form-item>
             </lk-col>
             <lk-col span='7' offset='1'>
               <lk-form-item label='商品毛重(g):' prop='grossWeight' ref="grossWeight">
                  <lk-input-number
                    ref="sfWeight"
                    v-if="able"
                    v-model.trim="goodsForm.grossWeight"
                    placeholder="请输入"
                    :max='99999'
                    :min='1'
                     @on-change='minPkgSizeChange'
                  ></lk-input-number>
                <span v-else>{{goodsForm.grossWeight || ''}}</span>
               </lk-form-item>
             </lk-col>
             <lk-col span='7' :offset='1'>
               <lk-form-item label='最小包装尺寸(mm):' prop='minPkgSize' ref="minPkgSize">
                 <div v-if="able" class="minPacking">
                    <lk-input-number
                      class="minPackingInput"
                      v-model.trim="goodsForm.minPkgLong"
                      placeholder="长"
                      :max='99999'
                      :min='1'
                      @on-change='minPkgSizeChange'
                    ></lk-input-number>
                    <lk-input-number
                      class="minPackingInput"
                      v-model.trim="goodsForm.minPkgWide"
                      placeholder="宽"
                      :max='99999'
                      :min='1'
                      @on-change='minPkgSizeChange'
                    ></lk-input-number>
                    <lk-input-number
                      v-model.trim="goodsForm.minPkgHigh"
                      placeholder="高"
                      :max='99999'
                      :min='1'
                      @on-change='minPkgSizeChange'
                    ></lk-input-number>
                 </div>
                  <span v-else>{{minPkgSizeCom}}</span>
               </lk-form-item>
             </lk-col>
           </lk-row>
           <!-- 顺丰增加字段结束 -->
        </lk-card>
      </div>
      <div class="cardContainer">
        <lk-card title='商品标签'>
          <lk-row :gutter='16'>
            <lk-col span='7'>
              <lk-form-item label='GSP管理分类:' class="storeSelect" prop='gspIdList'>
                <lk-select v-if="able" v-model="goodsForm.gspIdList" filterable multiple >
                  <lk-option v-for="(option,index) in baseData.label.gspArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.gsps }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='经营范围:' class="storeSelect" prop='bizIdList'>
                <lk-select v-if="able" v-model="goodsForm.bizIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.bizArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.bizs }}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='7' :offset='1'>
              <lk-form-item label='生产范围:' class="storeSelect">
                <lk-select v-if="able" v-model="goodsForm.prodIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.prodArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.prods }}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='7'>

              <lk-form-item label='其他:' class="storeSelect">
                <lk-select v-if="able" v-model="goodsForm.otherIdList" filterable multiple>
                  <lk-option v-for="(option,index) in baseData.label.otherArr" :value='option.id'
                    :key="index">{{option.name}}</lk-option>
                </lk-select>
                <span v-else>{{goodsForm.others }}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </lk-card>
      </div>
      <MedicationGuidance
        v-if="!isInStore"
        v-model="goodsForm"
        :isAdd='isAdd'
        :able='able'
      />
      <div class="cardContainer">
        <lk-card title='证件信息'>
          <lk-form :label-width='130' label-position="right" :model='goodsForm'
            ref="groupCheck" :rules='groupCheck'>
            <lk-row :gutter='16'>
              <lk-col class="backGroundCard" span='7'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='prodLicenseUrl'>
                      <div class="label withPic">
                        <label>生产许可证:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.prodLicenseUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='prodLicenseCode'>
                      <lk-input :maxlength='20' v-if="able" placeholder="请输入"
                        v-model.trim="goodsForm.prodLicenseCode"></lk-input>
                      <span v-else>{{goodsForm.prodLicenseCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' prop='periodProdLicense'  :class="{'ivu-form-item-required':requiredPeriodProdLicense}">
                      <expire-picker :type='1' :able='able' v-model.trim="goodsForm.periodProdLicense"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>
              <lk-col class="backGroundCard" span='7' :offset='1'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='gmpCertUrl'>
                      <div class="label withPic">
                        <label>GMP证书:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.gmpCertUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='gmpCertCode'>
                      <lk-input :maxlength='20' v-if="able" placeholder="请输入"
                        v-model.trim="goodsForm.gmpCertCode"></lk-input>
                      <span v-else>{{goodsForm.gmpCertCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' prop='periodGmpCert'  >
                      <expire-picker :able='able' :disableInfo='true' v-model.trim="goodsForm.periodGmpCert"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>

              <lk-col class="backGroundCard" span='7' :offset='1'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='drugRegApprovalUrl' :class="{'ivu-form-item-required':goodsForm.isImport===2 && !isFromBaseInfo}">
                      <div class="label withPic">
                        <label>药品注册批件:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.drugRegApprovalUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='drugRegApprovalCode' :class="{'ivu-form-item-required':goodsForm.isImport===2 && !isFromBaseInfo}">
                      <lk-input :maxlength='20' v-if="able" placeholder="请输入"
                        v-model.trim="goodsForm.drugRegApprovalCode"></lk-input>
                      <span v-else>{{goodsForm.drugRegApprovalCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' prop='periodDrugRegApproval'  :class="{'ivu-form-item-required':goodsForm.isImport===2 && !isFromBaseInfo}">
                      <expire-picker :able='able' v-model.trim="goodsForm.periodDrugRegApproval"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col class="backGroundCard" span='7'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='inspectionReportUrl'>
                      <div class="label withPic">
                        <label>检验报告书:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.inspectionReportUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='inspectionReportCode'>
                      <lk-input :maxlength='20' v-if="able" placeholder="请输入"
                        v-model.trim="goodsForm.inspectionReportCode"></lk-input>
                      <span v-else>{{goodsForm.inspectionReportCode}}</span>
                    </lk-form-item>
                  </lk-col>

                </lk-row>
              </lk-col>

              <lk-col class="backGroundCard" span='7' :offset='1'>
                <lk-row>
                  <lk-col span='24'>
                    <lk-form-item prop='importRegCertUrl' ref='importRegCertUrl' :class="{'ivu-form-item-required':goodsForm.isImport===1}">
                      <div class="label withPic">
                        <label>进口注册证:</label>
                      </div>
                      <Uploader :able='able' v-model.trim="goodsForm.importRegCertUrl">
                      </Uploader>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='证件号:' prop='importRegCertCode' ref='importRegCertCode' :class="{'ivu-form-item-required':goodsForm.isImport===1}">
                      <lk-input :maxlength='20' v-if="able" placeholder="请输入"
                        v-model.trim="goodsForm.importRegCertCode"></lk-input>
                      <span v-else>{{goodsForm.importRegCertCode}}</span>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='24'>
                    <lk-form-item label='有效期:' ref='periodImportRegCert' prop='periodImportRegCert'  :class="{'ivu-form-item-required':goodsForm.isImport===1}" >
                      <expire-picker :able='able' v-model.trim="goodsForm.periodImportRegCert"/>
                    </lk-form-item>
                  </lk-col>
                </lk-row>
              </lk-col>


            </lk-row>
            <lk-row>

            </lk-row>
          </lk-form>
        </lk-card>
      </div>
    </lk-form>
  </div>
</template>

<script>
import Uploader from '../../Uploader.vue';
import utils from '../../../libs/utils';
import ExpirePicker from '../../expireInfo/expirePicker.vue';
import goodsDropDownInput from '../goodsDropDownInput.vue';
import SelectInput from '../../selectInput.vue';
import drugInstruction from '../../drugInstruction.vue'; // 药品说明书
import MedicationGuidance from './MedicationGuidance.vue'; // 用药指导

export default {
  name: 'Drug',
  components: {
    drugInstruction, // yaopinshuomingshu  zujian
    Uploader,
    goodsDropDownInput,
    ExpirePicker,
    SelectInput,
    MedicationGuidance,
  },
  props: {
    info: {
      type: Object,
      // required: true,
    },
    able: {
      type: Boolean,
    },
    baseData: {
      type: Object,
    },
    isInStore: {
      type: Boolean,
      default: false,
    },
    isImport: {
      type: Boolean,
    },
    isFromBaseInfo: { // 药品类型和消杀类型的时间等是非必填
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'info',
    event: 'change',

  },
  watch: {
    info: {
      handler() {
        this.indicationDicArray = this.info.indicationDicArray ? this.info.indicationDicArray.split(',') : [];

        this.goodsForm = this.info;
        const {
          minPkgHigh, minPkgLong, minPkgWide, grossWeight,
        } = this.info;
        !minPkgHigh ? this.goodsForm.minPkgHigh = null : null;
        !minPkgLong ? this.goodsForm.minPkgLong = null : null;
        !grossWeight ? this.goodsForm.grossWeight = null : null;
        !minPkgWide ? this.goodsForm.minPkgWide = null : null;
      },
      deep: true,
    },
    goodsForm: {
      handler() {
        if (this.goodsForm.approvalNumberType) {
          this.validate.approvalNumber[this.validate.approvalNumber.length - 1].approvalNumberType = utils.getArrKey(this.baseData.approvalNumberTypeArr, this.goodsForm.approvalNumberType);
          console.log('test');
          if (this.goodsForm.approvalNumberType === '进口注册证号' || (this.goodsForm.approvalNumberType === '国药准字' && /^J/.test(this.goodsForm.approvalNumber))) {
            this.goodsForm.isImport = 1;
            this.$refs.importRegCertUrl.isRequired = true;
            this.$refs.importRegCertCode.isRequired = true;
          } else {
            this.$refs.importRegCertUrl.isRequired = false;
            this.$refs.importRegCertCode.isRequired = false;
            this.goodsForm.isImport = 2;
            this.groupCheck.periodImportRegCert = null; // 进口注册证有效期
            this.groupCheck.periodProdLicense = [{ // 生产许可证有效期
              required: this.requiredPeriodProdLicense, message: '请选择有效期', trigger: 'change', type: 'number',
            }];
            this.groupCheck.periodDrugRegApproval = [{ // 药品注册批件 有效期
              required: !this.isFromBaseInfo, message: '请选择有效期', trigger: 'change', type: 'number',
            }];
          }
        }
        this.firstCheck();
        this.$emit('change', this.goodsForm);
      },
      deep: true,
    },
    'goodsForm.approvalNumberType': {
      handler() {
        this.disableExistsTest = true;

        this.able
       && this.$refs.goodsForm.validateField('approvalNumber', () => {
         this.disableFirstCheck = false;
       });
      },
    },
    'goodsForm.isDockSf': {
      immediate: true,
      handler() {
        this.setAdditionalRemark();
        this.minPkgSizeChange();
      },
    },
    indicationDicArray: {
      handler(val) {
        if (val && val.length) {
          this.goodsForm.indicationDicId = val[val.length - 1];
          this.goodsForm.indicationDicArray = val.join(',');
        } else {
          this.goodsForm.indicationDicId = null;
          this.goodsForm.indicationDicArray = '';
        }
      },
      deep: true,
    },
  },
  computed: {
    sfValidate() {
      const {
        storageConditions,
        isDockSf,
      } = this.goodsForm;
      return this.storageConditionsIndexs.includes(storageConditions) && isDockSf === 1;
    },
    minPkgSizeCom() {
      const {
        minPkgLong,
        minPkgWide,
        minPkgHigh,
      } = this.goodsForm;
      let str = '';
      if (minPkgLong) {
        str += `长:${minPkgLong}`;
      }
      if (minPkgWide) {
        str += `宽:${minPkgWide}`;
      }
      if (minPkgHigh) {
        str += `高:${minPkgHigh}`;
      }
      return str;
    },
    requiredPeriodProdLicense() {
      if (this.isFromBaseInfo) { // 基础商品非必填
        return !this.isFromBaseInfo;
      }
      const key = utils.getArrKey(this.baseData.approvalNumberTypeArr, this.goodsForm.approvalNumberType);
      return !(key > 3) && this.goodsForm.isImport === 2; // 不是进口且选择列表前四个才必填生产许可证
    },
    isStoreAccount() {
      return this.$store.state.user.roleType === 2;
    },
    isAdd() {
      return !this.$route.params.id;
    },
    disabledSearch() {
      return !!this.$route.params.id || this.isImport;
    },
  },
  data() {
    return {
      storageConditionsIndexs: [5, 6],
      firstCheckArr: [
        'approvedDrugNames',
        'approvalNumber',
        'specifications',
        'drugMiniPackageUnit',
        'drugImageUrl',
        'manualUrl',
      ],
      antitumorTypeList: [
        {
          id: 1,
          name: '靶向药物',
        },
        {
          id: 2,
          name: '化疗药物',
        },
        {
          id: 3,
          name: '抗血管药物',
        },
        {
          id: 4,
          name: '抗肿瘤辅助用药',
        },
        {
          id: 5,
          name: '内分泌用药',
        },
        {
          id: 6,
          name: '免疫药物',
        },
      ],
      disableFirstCheck: false,
      disableExistsTest: false,
      ifShowTumourCategory: false,
      isImportArr: ['', '是', '否'],
      groupCheck: {

      },
      validate: {},
      goodsForm: {
        isImport: 2, // 是否进口 1是，2否
        storageConditions: 1,
        maxRxNum: 20,
        minTemp: null,
        maxTemp: null,
        isAntitumor: null,
        minPkgSize: '',
        minPkgLong: null,
        minPkgWide: null,
        minPkgHigh: null,
        grossWeight: null,
        isDockSf: 2,
      },
      firstFill: {},
      indicationDicArray: [],
      showInstruction: false,
      drugInstructionData: {

      },
    };
  },
  methods: {
    setAdditionalRemark() {
      const val = this.goodsForm.isDockSf;
      const index1 = this.firstCheckArr.indexOf('minPkgSize');
      const index2 = this.firstCheckArr.indexOf('grossWeight');
      const index3 = this.firstCheckArr.indexOf('storageConditions');
      if (val == 1) {
        this.$set(this.validate, 'minPkgSize', [
          { required: true, message: '请输入最小包装尺寸', trigger: 'blur' },
          { validator: this.minPkgSizeValidator, trigger: 'blur' },
        ]);
        this.$set(this.validate, 'grossWeight', [
          {
            required: true,
            message: '请输入商品毛重',
            trigger: 'change',
            type: 'number',
          },
        ]);
        index1 < 0 ? this.firstCheckArr.splice(this.firstCheckArr.length - 1, 0, 'minPkgSize') : null;
        index2 < 0 ? this.firstCheckArr.splice(this.firstCheckArr.length - 1, 0, 'grossWeight') : null;
        this.$nextTick(() => {
          this.$refs.minPkgSize.isRequired = true;
          this.$refs.grossWeight.isRequired = true;
        });
        if (!this.isInStore) {
          this.$set(this.validate, 'storageConditions', [
            {
              required: true, message: '请选择储存条件', trigger: 'change', type: 'number',
            },
            { validator: this.testOtherStorage, trigger: 'blur' },
          ]);
          this.$nextTick(() => {
            this.$refs.storageConditions.isRequired = true;
          });
          index3 < 0 ? this.firstCheckArr.splice(this.firstCheckArr.length - 1, 0, 'storageConditions') : null;
        }
      } else {
        this.$set(this.validate, 'minPkgSize', []);
        this.$set(this.validate, 'grossWeight', []);
        this.$nextTick(() => {
          this.$refs.minPkgSize.isRequired = false;
          this.$refs.grossWeight.isRequired = false;
          this.$refs.minPkgSize.validateMessage = '';
          this.$refs.minPkgSize.validateState = '';
          this.$refs.grossWeight.validateMessage = '';
          this.$refs.grossWeight.validateState = '';
        });
        index1 >= 0 ? this.firstCheckArr.splice(index1, 1) : null;
        index2 >= 0 ? this.firstCheckArr.splice(index1, 1) : null;
        if (!this.isInStore) {
          this.$set(this.validate, 'storageConditions', []);
          this.$nextTick(() => {
            this.$refs.storageConditions.isRequired = false;
            this.$refs.storageConditions.validateMessage = '';
            this.$refs.storageConditions.validateState = '';
          });
          index3 >= 0 ? this.firstCheckArr.splice(index1, 1) : null;
        }
      }
    },
    close() {
      this.showInstruction = false;
    },
    exchangeDictionary(arr, index) {
      return utils.exchangeDictionary(arr, index);
    },
    handleStorageConditions(val) {
      if (val === 1) {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      } else if (val === 2) {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      } else if (val === 3) {
        this.goodsForm.minTemp = 0;
        this.goodsForm.maxTemp = 20;
      } else if (val === 4) {
        this.goodsForm.minTemp = 2;
        this.goodsForm.maxTemp = 8;
      } else if (val === 5) {
        this.goodsForm.minTemp = -25;
        this.goodsForm.maxTemp = -20;
      } else {
        this.goodsForm.minTemp = null;
        this.goodsForm.maxTemp = null;
      }
    },
    firstCheck(reset) {
      this.goodsForm.approvedDrugNames && (this.$refs.approvedDrugNames.validateState = '');// 强制清除验证状态

      if (reset && (this.goodsForm.approvedDrugNames && this.goodsForm.approvalNumber && this.goodsForm.specifications)) {
        this.firstCheckArr.forEach((item) => {
          this.$refs.goodsForm.validateField(item, (msg) => {

          });
        });
        return;
      }

      if ((!this.disableFirstCheck && this.isInStore) && !(this.goodsForm.approvedDrugNames || this.goodsForm.approvalNumber || this.goodsForm.specifications)) {
        this.disableExistsTest = true;
        let firstFill = null;
        this.firstCheckArr.forEach((item) => {
          this.$refs.goodsForm.validateField(item, (msg) => {
            console.log(msg);
            if (msg) {
              firstFill = msg;
            }
          });
        });
        if (firstFill) {
          this.$Message.error('请先填写商品通用名 和 批准文号 和 规格');
        }
        this.disableExistsTest = false;
      }
    },

    setMnemonicCode(name) {
      this.$emit('setMnemonicCode', name);
    },
    handleSelect(data) {
      this.$emit('import', data);
    },
    validateForm(isSubmit) {
      this.$emit('change', this.goodsForm);
      return new Promise((resolve) => {
        let validate = true;
        this.disableExistsTest = true;
        if (this.sfValidate) {
          this.$Message.warning('储存条件为冷冻、其他的商品不支持对接顺丰');
          return;
        }
        if (isSubmit) { // 判断是否是提交操作，只有在提交的时候才校验证件信息的必填项
          if (this.goodsForm.isImport === 1) { // 是否进口 1是 2否
            this.groupCheck = Object.assign({}, this.groupCheck, {
              periodImportRegCert: [{
                required: true, message: '请选择进口注册证有效期', trigger: 'change', type: 'number',
              }],
              importRegCertUrl: [{
                required: true, message: '请上传进口注册证', trigger: 'change',
              }],
              importRegCertCode: [{
                required: true, message: '请输入证件号', trigger: 'change',
              }],
              drugRegApprovalUrl: [{
                required: false, trigger: 'change',
              }],
              drugRegApprovalCode: [{
                required: false, trigger: 'change',
              }],
              periodProdLicense: [{
                required: false, trigger: 'change',
              }],
              periodDrugRegApproval: [{
                required: false, trigger: 'change', type: 'number'
              }],
            })
            this.groupCheck.periodProdLicense = null; // 生产许可证有效期
          } else if (this.goodsForm.isImport === 2) {
            this.groupCheck.periodProdLicense = [{ // 生产许可证有效期
              required: this.requiredPeriodProdLicense, message: '请选择有效期', trigger: 'change', type: 'number',
            }];
            this.groupCheck = Object.assign({}, this.groupCheck, {
              periodDrugRegApproval: [{
                required: !this.isFromBaseInfo, message: '请选择有效期', trigger: 'change', type: 'number',
              }],
              drugRegApprovalUrl: [{
                required: !this.isFromBaseInfo, message: '请选择药品注册批件', trigger: 'change',
              }],
              drugRegApprovalCode: [{
                required: !this.isFromBaseInfo, message: '请选择药品注册证件号', trigger: 'change',
              }],
              importRegCertUrl: [{
                required: false, trigger: 'change',
              }],
              importRegCertCode: [{
                required: false, trigger: 'change',
              }],
              periodImportRegCert: [{
                required: false, trigger: 'change', type: 'number'
              }],
            })
          }
          this.$nextTick(() => {
            this.$refs.goodsForm.validate((goodsFormValid) => {
              this.$refs.groupCheck.validate((groupCheckValid) => {
                resolve(goodsFormValid && groupCheckValid);
                this.disableExistsTest = false;
              });
            });
          });
        } else {
          this.firstCheckArr.forEach((item) => {
            this.$refs.goodsForm.validateField(item, (msg) => {
              if (msg) {
                validate = false;
              }
            });
          });
          this.$nextTick(() => {
            this.disableExistsTest = false;
            resolve(validate);
          });
        }
      });
    },

    testTemp(rule, value, callback) {
      if (this.goodsForm.maxTemp != null && this.goodsForm.minTemp != null && this.goodsForm.maxTemp <= this.goodsForm.minTemp) {
        callback(
          new Error('最高温度应大于最低温度'),
        );
      }
      if (this.goodsForm.storageConditions === 6) {
        if (this.goodsForm.maxTemp === null && this.goodsForm.minTemp === null) {
          callback(
            new Error('当前储存条件下，温度必填'),
          );
        } else callback();
      } else if (this.goodsForm.storageConditions > 2 && this.goodsForm.storageConditions < 7) {
        if (this.goodsForm.maxTemp === null || this.goodsForm.minTemp === null) {
          callback(
            new Error('请输入完整温度范围'),
          );
        } else callback();
      } else callback();
    },
    testOtherStorage(rule, value, callback) {
      if (this.goodsForm.storageConditions === 6 && !this.goodsForm.otherStorageCondition) {
        callback(
          new Error('请输入储存条件名称'),
        );
      } else {
        callback();
      }
    },
    valideApprovalNumber() {
      this.$refs.goodsForm.validateField('approvalNumber');
    },
    approvalNumberTypeValidator(rule, value, callback) {
      if (this.goodsForm.approvalNumberType) {
        callback();
      } else {
        callback(
          new Error('请选择批准文号类型'),
        );
      }
    },
    minPkgSizeChange(val) {
      const {
        minPkgLong,
        minPkgWide,
        minPkgHigh,
      } = this.goodsForm;
      if (minPkgLong || minPkgWide || minPkgHigh) {
        this.goodsForm.minPkgSize = '';
        this.goodsForm.minPkgSize = `${minPkgLong || ''}X${minPkgWide || ''}X${minPkgHigh || ''}`;
      } else {
        this.goodsForm.minPkgSize = '';
      }
      if (val && val.toString().indexOf('.') !== -1) {
        this.$Message.warning('请输入整数');
      }
    },
    minPkgSizeValidator(rule, value, callback) {
      const {
        minPkgLong,
        minPkgWide,
        minPkgHigh,
      } = this.goodsForm;
      if (this.goodsForm.minPkgSize && !this.able) {
        callback();
      } else if (!minPkgLong || !minPkgWide || !minPkgHigh) {
        callback(
          new Error('请输入最小包装尺寸'),
        );
      } else {
        callback();
      }
    },
    existsTest(rule, value, callback) {
      if (!this.disabledSearch && !this.disableExistsTest && this.goodsForm.specifications && this.goodsForm.approvalNumber) {
        this.$emit('change', this.goodsForm);
        const result = (this.goodsForm.approvalNumberType && this.goodsForm.approvalNumber) && (this.goodsForm.approvalNumberType + this.goodsForm.approvalNumber);
        const temp = {
          approvalNumber: result,
          specifications: this.goodsForm.specifications,
        };
        result && this.$emit('handleExist', temp);
      }
      callback && callback();
    },
    ifSelectDrugMiniPackageUnit(rule, value, callback) {
      if (!this.goodsForm.drugMiniPackageUnit) {
        callback(new Error('请选择包装单位'));
      } else {
        callback();
      }
    },
  },
  created() {
    if (this.$route.params.id) {
      this.goodsForm = this.info;
    }
    if (this.isInStore) {
      this.validate = {
        drugImageUrl: [
          {
            required: true, message: '请上传药品图片', trigger: 'change',
          },
        ],
        manualUrl: [
          {
            required: true, message: '请上传说明书', trigger: 'change',
          },
        ],
        isDockSf: [
          {
            required: true, message: '请选择是否启用配送', trigger: 'change', type: 'integer',
          },
        ],
        approvedDrugNames: [
          { required: true, message: '请输入商品通用名', trigger: 'blur' },
        ],
        approvalNumber: [
          { required: true, message: '请输入批准文号', trigger: 'blur' },
          { validator: this.existsTest, trigger: 'blur' },
          { validator: this.approvalNumberTypeValidator, trigger: 'blur' },
          { validator: utils.validate.approvalNumberValidator, trigger: 'blur' },

        ],
        specifications: [
          { required: true, message: '请输入规格', trigger: 'change' },
          { validator: this.existsTest, trigger: 'blur' },
        ],

        temp: [{ required: true, validator: this.testTemp, trigger: 'blur' }],
        gspIdList: [{
          required: true, message: '请选择GSP管理分类', trigger: 'change', type: 'array',
        }],
        bizIdList: [{
          required: true, message: '请选择药品经营范围', trigger: 'change', type: 'array',
        }],
        // antitumorType: [],
        isDataLink: [
          {
            required: true, message: '请选择是否数据直连', trigger: 'change', type: 'integer',
          },
        ],
        dosageForm: [
          {
            required: true, message: '请选择剂型', trigger: 'change', type: 'number',
          },
        ],
        drugMiniPackageUnit: [
          {
            required: true, message: '请选择包装单位', trigger: 'change', type: 'number',
          },
        ],
        storageConditions: [
          {
            required: true, message: '请选择储存条件', trigger: 'change', type: 'number',
          },
          { validator: this.testOtherStorage, trigger: 'blur' },
        ],

        manufacturer: [
          { required: true, message: '请输入生产企业', trigger: 'change' },
        ],

        qualityOfDrugsType: [
          {
            required: true, message: '请选择质检分类', trigger: 'change', type: 'number',
          },
        ],
        drugAcceptanceStandard: [
          { required: true, message: '请输入质检标准', trigger: 'change' },
        ],
        prodLicenseCode: [{
          required: true, message: '请填写证件号', trigger: 'change',
        }],
        periodProdLicense: [{
          required: true, message: '请选择有效期', trigger: 'change', type: 'number',
        }],
      };
    } else {
      this.validate = {
        approvalNumber: [
          { required: true, message: '请输入批准文号', trigger: 'blur' },
          { validator: this.existsTest, trigger: 'blur' },
          { validator: this.approvalNumberTypeValidator, trigger: 'blur' },
          { validator: utils.validate.approvalNumberValidator, trigger: 'blur' },

        ],
        specifications: [
          { required: true, message: '请输入规格', trigger: 'change' },
          { validator: this.existsTest, trigger: 'blur' },
        ],
        approvedDrugNames: [
          {
            required: true, message: '请输入通用名', trigger: 'change',
          },
        ],
        drugMiniPackageUnit: [
          {
            required: true, message: '请选择包装单位', trigger: 'change', type: 'number',
          },
        ],
      };
    }
  },
  mounted() {
    if (this.$route.params.id) {
      this.disableFirstCheck = true;
      this.goodsForm = this.info;
      this.indicationDicArray = (this.info && this.info.indicationDicArray) ? this.info.indicationDicArray.split(',') : [];

      this.$nextTick(() => {
        this.disableFirstCheck = false;
      });
    }
  },
};
</script>

<style scoped>
  .cardContainer{
    margin-bottom: 16px
  }
  .storageConditions{
    display: flex;
    align-items: center;
    justify-content: space-between

  }

  .temperature{
    width:660px;
    display: flex;
    justify-content: flex-end
  }
  .fakeFormItem{
    margin-left: -36px
  }
  .other{
    width: 40%;
  }
  .minPacking {
    display: flex;
  }
  .minPackingInput {
    margin-right: 10px;
  }
  /deep/ .ivu-input-number {
    width: 100%;
  }
</style>
